// extracted by mini-css-extract-plugin
export default {"BaseCell":"repo-searcher-module__BaseCell--_V4bg","Box":"repo-searcher-module__Box--cOJVS"};